import { render, staticRenderFns } from "./Bigfox.vue?vue&type=template&id=5ab69f7e&"
import script from "./Bigfox.vue?vue&type=script&lang=js&"
export * from "./Bigfox.vue?vue&type=script&lang=js&"
import style0 from "./Bigfox.vue?vue&type=style&index=0&id=5ab69f7e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports